Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = dlv;
/* eslint-disable no-param-reassign */
function dlv(obj, key, def, p) {
  p = 0;
  key = key.split ? key.split('.') : key;
  while (obj && p < key.length) {
    obj = obj[key[p++]];
  }return obj === undefined ? def : obj;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/formera/lib/helpers/getIn.js
// module id = 72
// module chunks = 0